import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { ColorPicker } from 'ui-components/components/color-picker';
import { FlexRow, Gap } from 'ui-components/components/flex';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { DOCUMENT_COLOR_VALUES, hexToInt, intToHex } from './document-colors';
import { messages } from './messages';
import styles from './widget-properties.module.less';

import type { RequiredPropertyProps } from './types';
import type { Color } from '../../config';

type ColorPropertyInputProps = RequiredPropertyProps<Color | undefined> & {
  value: Color | undefined;
};

export const ColorPropertyInput = ({ id, updateWidget, value }: ColorPropertyInputProps) => {
  const currentColor = intToHex(value);
  const handleColorChange = (color: string) => {
    const intColor = hexToInt(color);
    updateWidget(intColor);
  };

  const handleClearColor = () => {
    updateWidget(undefined);
  };

  const { formatMessage } = useIntl();

  return (
    <FlexRow className={styles['color-property-wrapper']} gap={Gap.Space4}>
      <ColorPicker
        buttonClassName={styles['color-property-button']}
        className={styles['color-property']}
        colors={DOCUMENT_COLOR_VALUES}
        dropdownMenuType='ComboBox'
        id={id}
        isCompact
        onChange={handleColorChange}
        value={currentColor}
      />
      <Button
        ariaLabel={formatMessage(messages.clearColor)}
        className={styles['color-clear-button']}
        onClick={handleClearColor}
        theme={THEME_CONSTANTS.unstyled}
      >
        <FontAwesomeIcon icon={faTimes} />
      </Button>
    </FlexRow>
  );
};
